import { render, staticRenderFns } from "./BrandMobileSideMenu.vue?vue&type=template&id=916c16ee&scoped=true&"
import script from "./BrandMobileSideMenu.vue?vue&type=script&lang=ts&"
export * from "./BrandMobileSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMobileSideMenu.vue?vue&type=style&index=0&id=916c16ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916c16ee",
  null
  
)

export default component.exports